var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.979 20.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.635,188.146h-2.141v-.988a.988.988,0,0,0-1.976,0v.988h-5.625v-.988a.988.988,0,0,0-1.976,0v.988h-2.331a2.968,2.968,0,0,0-2.964,2.964v12.255a2.967,2.967,0,0,0,2.964,2.964h14.05a2.967,2.967,0,0,0,2.964-2.964V191.111A2.968,2.968,0,0,0,289.635,188.146Zm-14.05,1.976h2.331v.988a.988.988,0,0,0,1.976,0v-.988h5.625v.988a.988.988,0,1,0,1.976,0v-.988h2.141a.99.99,0,0,1,.988.988v2.683H274.6v-2.683A.99.99,0,0,1,275.584,190.123Zm14.05,14.231h-14.05a.989.989,0,0,1-.988-.988v-7.6h16.027v7.6A.989.989,0,0,1,289.635,204.354Z",
    transform: "translate(-272.62 -186.17)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.7d7ac50b.svg";
export { ForwardRef as ReactComponent };